import { render, staticRenderFns } from "./sectionCta.vue?vue&type=template&id=24e0a322"
import script from "./sectionCta.vue?vue&type=script&lang=js"
export * from "./sectionCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports